import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function MoneyBackGuarantee() {
  return <section className="w-full bg-white py-16" data-id="element-602">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-603">
        <div className="bg-emerald-50 rounded-xl p-8 md:p-12 text-center" data-id="element-604">
          <ShieldCheckIcon className="w-16 h-16 text-emerald-700 mx-auto mb-6" data-id="element-605" />
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-606">
            30-Day Money-Back Guarantee
          </h2>
          <p className="text-lg text-stone-700 leading-relaxed max-w-2xl mx-auto" data-id="element-607">
            If you're not satisfied for any reason, simply email us within 30
            days and we'll refund your purchase.
          </p>
        </div>
      </div>
    </section>;
}